/* eslint-disable max-len */
module.exports = {
  allUnits: 'Alle enhetene',
  addUnit: 'Legg til en ny enhet'
}
